import React from 'react';
import { SvgIcon, SvgIconProps, Box } from '@mui/material';
import icons from './iconMapping';

interface IconProps extends SvgIconProps {
  name: keyof typeof icons;
  size?: number;
  disabled?: boolean;
  sx?: {
    color?: string;
    [key: string]: any;
  };
}

const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  disabled = false,
  sx = {},
  ...props
}) => {
  const IconComponent = icons[name];

  if (!IconComponent) {
    console.error(`Icon "${name}" not found`);
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        opacity: disabled ? 0.4 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        color: sx?.color || 'inherit',
      }}
    >
      <SvgIcon
        component={IconComponent}
        inheritViewBox
        {...props}
        sx={{
          fontSize: size,
          width: '100%',
          height: '100%',
          ...sx,
        }}
      />
    </Box>
  );
};

export default Icon;
